import { useCallback } from 'react';

import { ZBError } from '@zenbusiness/application-commons-logging';

import { useUrlResolver } from './useUrlResolver';

/**
 * Builds the destination URL a product's Buy CTA points to (affiliate site, `/shop`
 * funnel, `/r/` redirect, or an internal dashboard page). Thin wrapper over the
 * canonical resolver (`productCta` context); throws when the product has no route, preserving
 * the original contract its one consumer (CTAButton) depends on.
 *
 * @returns {(product: string) => string} builder that returns the CTA URL or throws
 */
export default function useProductCtaUrl() {
  const resolve = useUrlResolver();

  return useCallback(
    (product) => {
      const { url, found } = resolve(product, { context: 'productCta' });

      if (!found) {
        throw new ZBError(`Could not find a product CTA url for ${product}`);
      }

      return url;
    },
    [resolve],
  );
}
